<template>
    <div class="o-page__sidebar js-page-sidebar">
        <div class="c-sidebar">
            <!-- <a class="c-sidebar__brand" href="/">
                <img class="c-sidebar__brand-img" src="/assets/img/logo.png" alt="Logo"> Dashboard
            </a> -->
            <div class="user__info">
                <div class="o-media">
                    <div class="o-media__img u-mr-xsmall">
                        <div class="c-avatar c-avatar--xsmall">
                            <img class="c-avatar__img" :src="photo!==''?photo:'/assets/img/placeholder.jpg'">
                        </div>
                    </div>
                    <div class="o-media__body">
                        {{name}}<small class="u-block u-text-mute">{{user_role_name}}</small>
                    </div>
                </div>
            </div>
            
            <h4 class="c-sidebar__title">Branch Visit Tools</h4>
            <ul class="c-sidebar__list">
                <li class="c-sidebar__item">
                    <router-link class="c-sidebar__link" to="/" exact-active-class="is-active">
                        <i class="el-icon-pie-chart u-mr-xsmall"></i>Dashboard
                    </router-link>
                </li>
                <li class="c-sidebar__item">
                    <router-link class="c-sidebar__link" to="/report" exact-active-class="is-active">
                        <i class="el-icon-tickets u-mr-xsmall"></i>Report
                    </router-link>
                </li>
                <!-- <li class="c-sidebar__item">
                    <router-link class="c-sidebar__link" to="/rating" exact-active-class="is-active">
                        <i class="el-icon-star-off u-mr-xsmall"></i>Rating History
                    </router-link>
                </li> -->
                <!-- <li class="c-sidebar__item">
                    <router-link class="c-sidebar__link" to="/employees" exact-active-class="is-active">
                        <i class="el-icon-trophy-1 u-mr-xsmall"></i>Employees
                    </router-link>
                </li> -->
                <li class="c-sidebar__item" v-if="user_role_id == 4">
                    <router-link class="c-sidebar__link" to="/categories" exact-active-class="is-active">
                        <i class="el-icon-collection-tag u-mr-xsmall"></i>Categories
                    </router-link>
                </li>
                <li class="c-sidebar__item" v-if="user_role_id == 4">
                    <router-link class="c-sidebar__link" to="/aspects" exact-active-class="is-active">
                        <i class="el-icon-finished u-mr-xsmall"></i>Aspects
                    </router-link>
                </li>
                <!-- <li class="c-sidebar__item" v-if="user_role_id == 4">
                    <router-link class="c-sidebar__link" to="/facilities" exact-active-class="is-active">
                        <i class="el-icon-school u-mr-xsmall"></i>Facilities
                    </router-link>
                </li> -->
            </ul>
            <h4 class="c-sidebar__title">Settings</h4>
            <ul class="c-sidebar__list">
                <li class="c-sidebar__item">
                    <router-link class="c-sidebar__link" to="/profile" exact-active-class="is-active">
                        <i class="el-icon-user u-mr-xsmall"></i>Profile
                    </router-link>
                </li>
                <li class="c-sidebar__item" v-if="user_role_id == 4">
                    <router-link class="c-sidebar__link" to="/users" exact-active-class="is-active">
                        <i class="el-icon-setting u-mr-xsmall"></i>Users
                    </router-link>
                </li>
                <li class="c-sidebar__item">
                    <a @click="logout" class="c-sidebar__link u-text-danger">
                        <i class="el-icon-switch-button u-mr-xsmall"></i>Logout
                    </a>
                </li>
            </ul>
        </div>
        <!-- // .c-sidebar -->
    </div>
    <!-- // .o-page__sidebar -->
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        name: 'sidebarmenu',
        data() {
            return {
                name: localStorage.getItem('name'),
                username: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                photo: localStorage.getItem('photo'),
                user_role_id: localStorage.getItem('user_role_id'),
                user_role_name: localStorage.getItem('user_role_id') == 4 ? 'Super Admin' : (localStorage.getItem('user_role_id') == 1 ? 'Admin' : (localStorage.getItem('user_role_id')==2?'Admin Wilayah':'Admin Outlet')),
                relation_code: localStorage.getItem('relation_code')
            }
        },
        mounted () {
            // console.log(localStorage.getItem('username'));
        },
        methods: {
            ...mapActions([
                'logout'
            ])
        },
    }
</script>

<style lang="scss" scoped>
.user__info {
    padding: 0.15rem 0.75rem;
    font-size: 0.8rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: #e2541b;
    color: white;
    .u-text-mute {
        color: white !important;
        opacity: .7 !important;
    }
}
.c-sidebar {
    background: #ffffff !important;
    border-right: 1px solid rgba(160, 175, 185, 0.15);
}
.c-sidebar__link {
    color: #5d676f;
}
.c-sidebar__item {
    padding: 0.15rem 0.75rem;
    .c-sidebar__link {
        border-radius: 3px;
        line-height: 2rem;
        padding: 0 0.5rem;
        &.is-active {
            color: #ffffff !important;
            background-color: #448bff !important;
        }
    }
}
</style>